// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — img.styled.classic.js, новая — img.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './img.styled.classic';
import * as cp from './img.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const ImgStyled = isCp ? cp.ImgStyled : classic.ImgStyled;
